import React, { FC } from 'react'
import { QueryClient, QueryClientProvider } from 'react-query'
import { queryClientConfig } from '../../dal/config/queryClientConfig'

interface IQueryClientProviderContainerProps {
  serverQueryClient?: QueryClient
  children: React.ReactElement
}

export const QueryClientProviderContainer: FC<IQueryClientProviderContainerProps> = ({
  serverQueryClient,
  children,
}) => {
  const [queryClient] = React.useState(() => serverQueryClient || new QueryClient(queryClientConfig))

  return (
    <div>
      <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
    </div>
  )
}
